// @mui
import { enUS, elGR } from '@mui/material/locale';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    label: 'Greek',
    value: 'el',
    systemValue: elGR,
    icon: '/assets/icons/flags/gr.svg',
  },
];

export const defaultLang = allLangs[0]; // English
